<template>
  <div>
    <PageAllow controller="Payment" action="getPaySettings" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("Payment.LKLPay.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <!-- lakala_url -->
              <v-row class="mt-5">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.LKLPay.lakala_url") + $t("Global.colon") }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LKLPay.lakala_url')"
                    rules="required"
                  >
                    <v-textarea
                      v-model="lklSettings.lakala_url"
                      outlined
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lakala_url')
                          .concat(errors)
                      "
                    >
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lakala_rsa_privateKey -->
              <v-row class="mt-3">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LKLPay.lakala_rsa_privateKey") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <v-file-input
                    v-model="lakalaRsaPrivateKeyFile"
                    show-size
                    :label="$t('Payment.LKLPay.lakala_rsa_privateKey_upload')"
                    :error-messages="
                      $resparse.getErrorMsgs(
                        serverErrors,
                        'lakala_rsa_privateKey'
                      )
                    "
                  ></v-file-input>
                  <v-text-field
                    v-model="lklSettings.lakala_rsa_privateKey"
                    single-line
                    disabled
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- lakala_rsa_password -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LKLPay.lakala_rsa_password") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LKLPay.lakala_rsa_password')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lklSettings.lakala_rsa_password"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lakala_rsa_password')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lakala_dsa_privateKey -->
              <v-row class="mt-3">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LKLPay.lakala_dsa_privateKey") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <v-file-input
                    v-model="lakalaDsaPrivateKeyFile"
                    show-size
                    :label="$t('Payment.LKLPay.lakala_dsa_privateKey_upload')"
                    accept=".pfx"
                    :error-messages="
                      $resparse.getErrorMsgs(
                        serverErrors,
                        'lakala_dsa_privateKey'
                      )
                    "
                  ></v-file-input>
                  <v-text-field
                    v-model="lklSettings.lakala_dsa_privateKey"
                    single-line
                    disabled
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- lakala_dsa_password -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LKLPay.lakala_dsa_password") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LKLPay.lakala_dsa_password')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lklSettings.lakala_dsa_password"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lakala_dsa_password')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lakala_dsa_publicKey -->
              <v-row class="mt-3">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LKLPay.lakala_dsa_publicKey") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <v-file-input
                    v-model="lakalaDsaPublicKeyFile"
                    show-size
                    :label="$t('Payment.LKLPay.lakala_dsa_publicKey_upload')"
                    accept=".pem"
                    :error-messages="
                      $resparse.getErrorMsgs(
                        serverErrors,
                        'lakala_dsa_publicKey'
                      )
                    "
                  ></v-file-input>
                  <v-text-field
                    v-model="lklSettings.lakala_dsa_publicKey"
                    single-line
                    disabled
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- lakala_rsa_publicKey -->
              <v-row class="mt-3">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LKLPay.lakala_rsa_publicKey") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <v-file-input
                    v-model="lakalaRsaPublicKeyFile"
                    show-size
                    :label="$t('Payment.LKLPay.lakala_rsa_publicKey_upload')"
                    accept=".pem"
                    :error-messages="
                      $resparse.getErrorMsgs(
                        serverErrors,
                        'lakala_rsa_publicKey'
                      )
                    "
                  ></v-file-input>
                  <v-text-field
                    v-model="lklSettings.lakala_rsa_publicKey"
                    single-line
                    disabled
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- lakala_appId -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.LKLPay.lakala_appId") + $t("Global.colon") }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LKLPay.lakala_appId')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lklSettings.lakala_appId"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lakala_appId')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lakala_sellerId -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LKLPay.lakala_sellerId") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LKLPay.lakala_sellerId')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lklSettings.lakala_sellerId"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lakala_sellerId')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lakala_expire_time -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LKLPay.lakala_expire_time") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col>
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LKLPay.lakala_expire_time')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lklSettings.lakala_expire_time"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lakala_expire_time')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <!-- lakala_seller_merchant_no -->
              <!--              <v-row align="center">-->
              <!--                <v-col cols="3" class="font-weight-bold text-right">-->
              <!--                  {{ $t("Payment.LKLPay.lakala_seller_merchant_no") + $t("Global.colon") }}-->
              <!--                  <span class="red&#45;&#45;text">*</span>-->
              <!--                </v-col>-->
              <!--                <v-col cols="9" md="7">-->
              <!--                  <ValidationProvider-->
              <!--                    v-slot="{ errors }"-->
              <!--                    :name="$t('Payment.LKLPay.lakala_seller_merchant_no')"-->
              <!--                    rules="required"-->
              <!--                  >-->
              <!--                    <v-text-field-->
              <!--                      v-model="lklSettings.lakala_seller_merchant_no"-->
              <!--                      single-line-->
              <!--                      :error-messages="-->
              <!--                        $resparse-->
              <!--                          .getErrorMsgs(serverErrors, 'lakala_seller_merchant_no')-->
              <!--                          .concat(errors)-->
              <!--                      "-->
              <!--                    >-->
              <!--                    </v-text-field>-->
              <!--                  </ValidationProvider>-->
              <!--                </v-col>-->
              <!--              </v-row>-->
              <!-- lakala_member_role -->
              <v-row
                align="center"
                v-if="
                  (settings &&
                    settings.sub_account_enable &&
                    settings.lkl_sub_account_enable) ||
                  lakalaBalancPay == '1'
                "
              >
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LKLPay.lakala_member_role") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LKLPay.lakala_member_role')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lklSettings.lakala_member_role"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lakala_member_role')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lakala_cash_fee -->
              <v-row
                align="center"
                v-if="
                  (settings &&
                    settings.sub_account_enable &&
                    settings.lkl_sub_account_enable) ||
                  lakalaBalancPay == '1'
                "
              >
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LKLPay.lakala_cash_fee") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LKLPay.lakala_cash_fee')"
                    :rules="{
                      min_value: { min: 0 },
                      required: { required: true },
                    }"
                  >
                    <v-text-field
                      v-model="lklSettings.lakala_cash_fee"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lakala_cash_fee')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lakala_type -->
              <v-row align="center" v-if="false">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.LKLPay.lakala_type") + $t("Global.colon") }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group
                    row
                    v-model="lklSettings.lakala_type"
                    value="1"
                  >
                    <v-radio :label="$t('Payment.off')" key="1" value="1" />
                    <v-radio :label="$t('Payment.on')" key="2" value="2" />
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- lakala_balance_pay -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LKLPay.lakala_balance_pay") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="lakalaBalancPay">
                    <v-radio :label="$t('Payment.off')" key="0" value="0" />
                    <v-radio :label="$t('Payment.on')" key="1" value="1" />
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- lakala_special_account_no -->
              <v-row align="center" v-if="lakalaBalancPay == '1'">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LKLPay.lakala_special_account_no") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LKLPay.lakala_special_account_no')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lklSettings.lakala_special_account_no"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(
                            serverErrors,
                            'lakala_special_account_no'
                          )
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lakalapay_enable -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LKLPay.lakalapay_enable") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="lklSettings.lakalapay_enable">
                    <v-radio :label="$t('Payment.off')" key="0" value="0" />
                    <v-radio :label="$t('Payment.on')" key="1" value="1" />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                color="success"
                block
                @click="
                  lklSettings.lakalapay_enable == 1
                    ? (alertDialog = true)
                    : save()
                "
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("Payment.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>

    <DialogAlert
      v-model="alertDialog"
      :message="$t('Payment.change_wechat_pay', [$t('Payment.lklpay')])"
      useConfirm
      @confirm="save()"
    />
  </div>
</template>

<script>
import Payment from "@/api/payment";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import DialogAlert from "@/components/plugins/DialogAlert";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  data: () => ({
    lklSettings: {},
    lakalaBalancPay: 0,
    serverErrors: [],
    lakalaRsaPrivateKeyFile: null,
    lakalaDsaPrivateKeyFile: null,
    lakalaDsaPublicKeyFile: null,
    lakalaRsaPublicKeyFile: null,
    oldLakalaRsaPrivateKey: "",
    oldLakalaDsaPrivateKey: "",
    oldLakalaDsaPublicKey: "",
    oldLakalaRsaPublicKey: "",
    alertDialog: false,
  }),

  components: {
    PageAllow,
    Breadcrumbs,
    DialogAlert,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.payment"),
        disabled: true,
        href: "/payment",
      },
    ],
    ...mapState(["loading", "settings"]),
  },

  mounted() {
    this.getAlipayFromAPI();
  },

  methods: {
    getAlipayFromAPI() {
      Payment.fetch({
        keys: [
          "lakala_url",
          "lakala_rsa_privateKey",
          "lakala_rsa_password",
          "lakala_dsa_privateKey",
          "lakala_dsa_password",
          "lakala_dsa_publicKey",
          "lakala_rsa_publicKey",
          "lakala_appId",
          "lakala_sellerId",
          "lakala_expire_time",
          "lakala_member_role",
          "lakala_cash_fee",
          "lakala_type",
          "lakala_balance_pay",
          "lakala_special_account_no",
          "lakalapay_enable",
        ],
        parse: 0,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.lklSettings = response.data.settings;
            this.lklSettings.lakala_type = "1";
            this.oldLakalaRsaPrivateKey =
              this.lklSettings.lakala_rsa_privateKey;
            this.oldLakalaDsaPrivateKey =
              this.lklSettings.lakala_dsa_privateKey;
            this.oldLakalaDsaPublicKey = this.lklSettings.lakala_dsa_publicKey;
            this.oldLakalaRsaPublicKey = this.lklSettings.lakala_rsa_publicKey;
            if (
              this.lklSettings.lakalapay_enable == null ||
              typeof this.lklSettings.lakalapay_enable == "undefined" ||
              this.lklSettings.lakalapay_enable == undefined
            ) {
              this.lklSettings.lakalapay_enable = "0";
            }
            if (
              this.lklSettings.lakala_balance_pay == null ||
              typeof this.lklSettings.lakala_balance_pay == "undefined" ||
              this.lklSettings.lakala_balance_pay == undefined
            ) {
              this.lakalaBalancPay = "0";
            } else {
              this.lakalaBalancPay = this.lklSettings.lakala_balance_pay;
            }
          }
        }.bind(this)
      );
    },

    save() {
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            Payment.LKLPaySave(this.lklSettings).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$router.push("/payment");
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
  },

  watch: {
    lakalaBalancPay: {
      handler() {
        this.lklSettings.lakala_balance_pay = this.lakalaBalancPay;
      },
    },
    lakalaRsaPrivateKeyFile: {
      handler() {
        if (this.lakalaRsaPrivateKeyFile) {
          Payment.lakalaFileUpload(this.lakalaRsaPrivateKeyFile, 2).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.lklSettings.lakala_rsa_privateKey =
                  response.data.lakala_rsa_private_file_url;
              }
            }.bind(this)
          );
        } else {
          this.lklSettings.lakala_rsa_privateKey = this.oldLakalaRsaPrivateKey;
        }
      },
    },
    lakalaDsaPrivateKeyFile: {
      handler() {
        if (this.lakalaDsaPrivateKeyFile) {
          Payment.lakalaFileUpload(this.lakalaDsaPrivateKeyFile, 1).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.lklSettings.lakala_dsa_privateKey =
                  response.data.lakala_dsa_private_file_url;
              }
            }.bind(this)
          );
        } else {
          this.lklSettings.lakala_dsa_privateKey = this.oldLakalaDsaPrivateKey;
        }
      },
    },
    lakalaDsaPublicKeyFile: {
      handler() {
        if (this.lakalaDsaPublicKeyFile) {
          Payment.lakalaFileUpload(this.lakalaDsaPublicKeyFile, 3).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.lklSettings.lakala_dsa_publicKey =
                  response.data.lakala_dsa_public_file_url;
              }
            }.bind(this)
          );
        } else {
          this.lklSettings.lakala_dsa_publicKey = this.oldLakalaDsaPublicKey;
        }
      },
    },
    lakalaRsaPublicKeyFile: {
      handler() {
        if (this.lakalaRsaPublicKeyFile) {
          Payment.lakalaFileUpload(this.lakalaRsaPublicKeyFile, 4).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.lklSettings.lakala_rsa_publicKey =
                  response.data.lakala_rsa_public_file_url;
              }
            }.bind(this)
          );
        } else {
          this.lklSettings.lakala_rsa_publicKey = this.oldLakalaRsaPublicKey;
        }
      },
    },
  },
};
</script>